var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29289 5.29292C7.68342 4.9024 8.31658 4.9024 8.70711 5.29292L12.7071 9.29292C13.0976 9.68345 13.0976 10.3166 12.7071 10.7071C12.3166 11.0977 11.6834 11.0977 11.2929 10.7071L8 7.41424L4.70711 10.7071C4.31658 11.0977 3.68342 11.0977 3.29289 10.7071C2.90237 10.3166 2.90237 9.68345 3.29289 9.29292L7.29289 5.29292Z",
    fill: "#001A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/Chevron-Up.3e839e90e11ed8c75803b825801e40e2.svg";
export { ForwardRef as ReactComponent };